/* eslint-disable import/no-anonymous-default-export */
import { GET_TIPO_CAMBIO } from "../actions/types";
const initialState = [];

const tipoCambioReducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_TIPO_CAMBIO:
      return {
        ...state,
        valores: payload,
      };
   
    default:
      return state;
  }
};

export default tipoCambioReducer;
